











































































































































import { Component, Vue } from 'vue-property-decorator'

@Component

export default class ComponentModalSolicitacaoCirurgiaMedicoItemAutorizado extends Vue {
  messages: any[] = []
}

